document.addEventListener('DOMContentLoaded', function() {
  // Vérifier si l'utilisateur est sur la page du panier
  if (window.location.pathname === '/cart') {
    // Fonction pour rafraîchir la page avec un délai
    function refreshPageAfterDelay(delay) {
      setTimeout(() => {
        location.reload();
      }, delay);
    }

    // Sélectionner les boutons de quantité (+ et -)
    const quantityButtons = document.querySelectorAll('.quantity__button');

    quantityButtons.forEach(button => {
      button.addEventListener('click', function() {
        // Ajouter un délai de 1,2 secondes avant de rafraîchir la page
        refreshPageAfterDelay(1200);  // 1200 millisecondes = 1,2 secondes
      });
    });

    // Sélectionner les boutons de suppression d'articles
    const removeButtons = document.querySelectorAll('a[href*="/cart/change?id="]');

    removeButtons.forEach(button => {
      button.addEventListener('click', function(event) {
        // Ajouter un délai de 1,2 secondes avant de rafraîchir la page
        refreshPageAfterDelay(1200);  // 1200 millisecondes = 1,2 secondes
      });
    });
  }
});





